"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Component = void 0;
var Preact = __importStar(require("preact"));
var AppBar_1 = __importDefault(require("@mui/material/AppBar"));
var sizing_1 = require("./sizing");
var styles_1 = require("@mui/material/styles");
var Component = function (props) {
    var theme = (0, styles_1.useTheme)();
    return (Preact.h(AppBar_1.default, { sx: __assign({ height: "".concat(sizing_1.appBarHeight, "px"), zIndex: theme.zIndex.appBar, width: '100%', paddingX: '12px', paddingY: '8px', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', boxSizing: 'border-box', top: 0, backgroundColor: props.colorVariant === 'light' ? 'background.default' : 'secondary.main' }, props.sx) }, props.children));
};
exports.Component = Component;
